// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};

exports.components = {
  "component---node-modules-narative-gatsby-theme-novela-src-templates-article-template-tsx": function componentNodeModulesNarativeGatsbyThemeNovelaSrcTemplatesArticleTemplateTsx() {
    return import("./../@narative/gatsby-theme-novela/src/templates/article.template.tsx"
    /* webpackChunkName: "component---node-modules-narative-gatsby-theme-novela-src-templates-article-template-tsx" */
    );
  },
  "component---node-modules-narative-gatsby-theme-novela-src-templates-articles-template-tsx": function componentNodeModulesNarativeGatsbyThemeNovelaSrcTemplatesArticlesTemplateTsx() {
    return import("./../@narative/gatsby-theme-novela/src/templates/articles.template.tsx"
    /* webpackChunkName: "component---node-modules-narative-gatsby-theme-novela-src-templates-articles-template-tsx" */
    );
  },
  "component---node-modules-narative-gatsby-theme-novela-src-templates-author-template-tsx": function componentNodeModulesNarativeGatsbyThemeNovelaSrcTemplatesAuthorTemplateTsx() {
    return import("./../@narative/gatsby-theme-novela/src/templates/author.template.tsx"
    /* webpackChunkName: "component---node-modules-narative-gatsby-theme-novela-src-templates-author-template-tsx" */
    );
  },
  "component---src-pages-404-js": function componentSrcPages404Js() {
    return import("./../../src/pages/404.js"
    /* webpackChunkName: "component---src-pages-404-js" */
    );
  }
};